import { create } from 'zustand'

/** The keys of one chat message's selected loads. Session only: a reload clears it (the chat is per page load). */
interface SelectionState {
    byMessage: Record<string, string[]>
    setSelected: (messageId: string, key: string, on: boolean) => void
    setAll: (messageId: string, keys: string[], on: boolean) => void
    clear: (messageId: string) => void
}

export const EMPTY_KEYS: string[] = []

/** The selection of each chat table, by message. Survives filter changes; not persisted. */
export const useInvoicingSelectionStore = create<SelectionState>()((set) => ({
    byMessage: {},
    setSelected: (messageId, key, on) =>
        set((state) => {
            const current = state.byMessage[messageId] ?? EMPTY_KEYS
            const without = current.filter((k) => k !== key)
            return { byMessage: { ...state.byMessage, [messageId]: on ? [...without, key] : without } }
        }),
    setAll: (messageId, keys, on) =>
        set((state) => {
            const current = state.byMessage[messageId] ?? EMPTY_KEYS
            const next = on ? [...current.filter((k) => !keys.includes(k)), ...keys] : current.filter((k) => !keys.includes(k))
            return { byMessage: { ...state.byMessage, [messageId]: next } }
        }),
    clear: (messageId) => set((state) => ({ byMessage: { ...state.byMessage, [messageId]: EMPTY_KEYS } })),
}))
